import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const POPUP_STORAGE_KEY = 'archiefpunt-popup-shown';

const hasSeenPopup = () => {
    try {
        return sessionStorage.getItem(POPUP_STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
};

const markPopupAsSeen = () => {
    try {
        sessionStorage.setItem(POPUP_STORAGE_KEY, '1');
    } catch (e) {
        // sessionStorage unavailable (e.g. privacy mode), popup will show again
    }
};

const handleFancybox = () => {

    Fancybox.bind('[data-fancybox]', {
        placeFocusBack: false,
        Thumbs: {
            showOnStart: true,
        },
        Toolbar: {
            display: {
                left: [],
                middle: ['prev', 'infobar', 'next'],
                right: ['thumbs', 'close']
            }
        }
    });

    Fancybox.bind('[data-fancybox-modal]', {});

}

const handlePopup = () => {
    const popup = document.querySelector('[data-popup]');
    if (!popup || hasSeenPopup()) return;

    // Mount inside #archief-app, all component styles are scoped to it
    Fancybox.show([{ src: popup, type: 'inline' }], {
        parentEl: document.getElementById('archief-app'),
        autoFocus: false,
    });

    markPopupAsSeen();
}

export { handleFancybox, handlePopup }
